<template>
  <div>
    <el-container>
      <el-header>
        <div style="float: right; font-size: 20px">
          <div>
            <el-button-group>
              <el-button size="medium" @click="logout()">登录/退出</el-button>
              <!-- <el-button size="medium" @click="cart()">购物车</el-button>
            <el-button size="medium" @click="order()">所有订单</el-button>
            <el-button size="medium" @click="khchangepw()">修改密码</el-button> -->
            </el-button-group>
          </div>
          <div style="margin-top: 5px">
            {{ swelcome }}
          </div>
        </div>

        <div style="text-align: left">
          <img src="/xibc.png" width="550px" />
        </div>
        <div >
          <el-menu
            :default-active="this.$router.path"
            router
            mode="horizontal"
            background-color="#545c64"
            text-color="#fff"
            active-text-color="#ffd04b"
          >
            <el-menu-item
              v-for="(item, i) in navList"
              style="font-size: 24px"
              :key="i"
              :index="item.name"
              >{{ item.navItem }}</el-menu-item
            >
          </el-menu>
        </div>
      </el-header>

      <el-main>
        <router-view></router-view>
      </el-main>

      <el-footer>
        <div>2017 厦门外图集团有限公司版权所有丨法律声明及隐私条款</div>
        <div>出版物经营许可证：新出发闽批字第XM4002号</div>
        <!-- <div>闽ICP备05024024号‍-1丨闽公安备案 35020602000373号丨出版物经营许可证：新出发闽批字第XM4002号</div> -->
        <!-- <div>地址：厦门市湖里区悦华路八号外图大厦丨电话：0592-5087235丨邮编：361000</div> -->
        <div>
          <el-link href="https://beian.miit.gov.cn/" target="_blank"
            >闽ICP备05024024号-6</el-link
          >
        </div>
        <div>
          <el-link
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35020602002313"
            target="_blank"
            >闽公安备案 35020602002313号</el-link
          >
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
// import search from "@/components/search.vue";
import axios from "axios";
import Qs from "qs";
import global from "../global.vue";
import AES from "../AES.js";

export default {
  components: {
    // search
  },
  data() {
    return {
      swelcome: "欢迎",
      navList: [
        {
          name: "/qtindex/qthomepage",
          navItem: "首    页",
        },
        {
          // name: "/qtindex/xkfl",
          name: "/qtindex/xkfl/0",
          // name: "{name:'xkfl',params:{sscope:0}}",
          navItem: "所有图书",
        },
        // {
        //   name: "/qtindex/ztfl",
        //   navItem: "中图分类",
        // },
        {
          name: "/qtindex/mrxs/1",
          // name: "/qtindex/xkfl?scope=1",
          // name: "{name:'xkfl',params:{sscope:1}}",
          // name: "/qtindex/mrxs",
          navItem: "每日新书",
        },
        {
          name: "/qtindex/bzxs/2",
          // name: "/qtindex/xkfl?scope=2",
          // name: "{name:'xkfl',params:{sscope:2}}",
          // name: "/qtindex/bzxs",
          navItem: "每周新书",
        },
        {
          name: "/qtindex/dyxs/3",
          // name: "/qtindex/xkfl?scope=3",
          // name: "{name:'xkfl',params:{sscope:3}}",
          // name: "/qtindex/dyxs",
          navItem: "每月新书",
        },
        // {
        //   name: "/qtindex/buyerroom",
        //   navItem: "注意事项"
        // },
        {
          name: "/qtindex/shoppingcart",
          navItem: "购物车",
        },
        {
          name: "/qtindex/orderlist",
          navItem: "订单列表",
        },
        {
           name: "/qtindex/deliverylist",
          navItem: "装箱清单",
        },
        {         name: "/qtindex/changepw",
          navItem: "更改密码",
        },
      ],
    };
  },
  created() {
    this.getdata();
  },
  methods: {
    getdata() {
      this.swelcome =
        "欢迎" +
        AES.decrypt(window.localStorage.getItem("sloginname"), global.AEScode);
    },
    logout() {
      var stoken = window.localStorage.getItem("stoken");
      var stokenenc = AES.encrypt(stoken, global.AEScode);
      window.localStorage.removeItem("stoken");
      window.localStorage.removeItem("scustomerid");
      window.localStorage.removeItem("douttime");
      let that = this;
      axios({
        headers: {
          "Content-type": "text/xml",
          token: stoken,
        },
        method: "post",
        url: global.sserverip + "logout",
        data: stokenenc,
      })
        .then(function (res) {
          console.log(res);
          let oresult = res.data;
          oresult = AES.decrypt(oresult, global.AEScode);
          console.log("--------------------------------------------------");
          console.log(oresult);
        })
        .catch(function (err) {
          console.log(err);
        });
      /*在这里进行跨域请求*/
      location.assign(global.swebip);
    },
    cart() {
      location.assign(global.swebip + "qtindex/shoppingcart");
    },
    order() {
      location.assign(global.swebip + "qtindex/orderlist");
    },
    khchangepw() {
      location.assign(global.swebip + "qtindex/changepw");
    },
  },
};
</script>

<style>
.el-container {
  height: 100%;
  min-width: 1440px;
}
.el-header,
.el-footer {
  background-color: #ffffff;
  color: #333;
  text-align: center;
}
.el-header {
  min-height: 120px;
  height: none !important;
}
.el-footer {
  height: 120px;
  font-size: small;
}
.el-main {
  color: rgb(0, 0, 0);
  text-align: center;
  min-height: 600px;
  font-size: small;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}

.el-table {
  color: #000000;
}
textarea {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
.el-input {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
</style>